export default __webpack_public_path__ + "static/media/loginImg.1bc5fc92.jpg";